import axios from 'axios'
import { MapperService } from '.'
import { URLS } from '../factories'
import { ApplicationModule, AuthModule } from '../store'

let retryLimit = 1

export default {
  async sendPartialApp (appInsights: any) {
    let token = AuthModule.token && AuthModule.token.authenticationToken !== null ? AuthModule.token.authenticationToken : null

    if (token !== null) {
      let tokenUpdateTime = AuthModule.token && AuthModule.token.tokenUpdateTime ? AuthModule.token.tokenUpdateTime : 0
      let authenticationTokenLifetime = AuthModule.token && AuthModule.token.authenticationTokenLifetime ? AuthModule.token.authenticationTokenLifetime  : 0
      if (tokenUpdateTime + authenticationTokenLifetime < Math.floor(Date.now() / 1000) ) {
        await AuthModule.updateAuthToken();
        token = AuthModule.token && AuthModule.token.authenticationToken !== null ? AuthModule.token.authenticationToken : null
      }

      const tokenString = 'Bearer ' + token
      const headersObj = { Authorization: tokenString }

      if (ApplicationModule.form.email === '' && ApplicationModule.form.contactNumber === '') {
        return
      }

      const partialData = MapperService.map()

      const requestURL = AuthModule.isProduction ? URLS.production.applicationApiPartialUrl : URLS.replica.applicationApiPartialUrl

      let response = null

      try {
        if (ApplicationModule.GUID === '') {
          ApplicationModule.updateGUID()
        }

        response = await axios({
          method: 'POST',
          url: requestURL + '/api/application/' + ApplicationModule.GUID,
          headers: headersObj,
          data: partialData
        })
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          // maybe update the token in case it's out of date

          if (retryLimit > 0) {
            retryLimit--
            AuthModule.updateAuthToken()
              .then(() => {
                this.sendPartialApp(appInsights)
              })
          }
        }

        appInsights.trackEvent({
          name: 'Application Form - Partial App Error',
          properties: {
            event_category: 'Application Form',
            event_action: 'Partial App Error',
            event_label: error.message + ' guid: ' + ApplicationModule.GUID
          }
        })
      }

      if (response === null) {
        return
      }

      appInsights.trackEvent({
        name: 'Application Form - Partial App',
        properties: {
          event_category: 'Application Form',
          event_action: 'Partial App',
          event_label: ApplicationModule.GUID
        }
      })
    }
  }
}
